<template>
  <div class="side-menu">
    <div class="menu-wrapper">
      <board-menu
        ref="menuList"
        :menu-list="chartMenus"
        @select="selectMenu"
        :active="curTab"
        class="chart-menu"
      ></board-menu>
      <template v-if="curTab === '基本信息'">
        <div class="basic-info">
          <div class="item">
            <div class="title">图表信息</div>
            <div class="content">
              <div class="content-item">
                <div class="label">
                  统计图名称
                  <span class="require-flag">*</span>
                </div>
                <div class="value">
                  <el-input v-model="chart.name" placeholder="请输入统计图名称"></el-input>
                  <el-checkbox v-model="chart.showName" class="show-name">显示名称</el-checkbox>
                </div>
              </div>
              <div class="content-item">
                <div class="label">描述</div>
                <el-input
                  v-model="chart.desc"
                  class="value"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入描述"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="title">数据权限</div>
            <div class="content">
              <div class="content-item">
                <div class="label">跟随看板</div>
                <el-radio-group
                  :value="chart.canSeeAll === null"
                  @input="changeDataPermission"
                  class="value"
                  style="margin-top: 3px"
                >
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </div>
              <template v-if="chart.canSeeAll !== null">
                <div class="content-item">
                  <div class="label">数据范围</div>
                  <el-radio-group v-model="chart.canSeeAll" class="value">
                    <el-radio :label="true" style="margin: 3px 0 15px;">全部数据</el-radio>
                    <el-radio :label="false">应用角色的数据范围</el-radio>
                  </el-radio-group>
                </div>
                <div class="content-item">
                  <div class="label">导出</div>
                  <div class="value">
                    <el-checkbox v-model="chart.canExportImage" style="margin-bottom: 15px;">
                      允许导出图片
                    </el-checkbox>
                    <el-checkbox v-model="chart.canExportExcel">允许导出数据</el-checkbox>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
      <template v-if="curTab === '样式配置'">
        <div v-ps key="styleSetting">
          <div class="style-setting">
            <template
              v-if="
                [
                  'basic-bar',
                  'stacked-basic-bar',
                  'bar',
                  'stacked-bar',
                  'line',
                  'smoothed-line',
                  'area-chart'
                ].includes(chart.type)
              "
            >
              <div class="item">
                <div class="title">图表样式</div>
                <div class="content">
                  <el-checkbox
                    v-if="!['bar', 'stacked-bar'].includes(chart.type)"
                    class="content-item"
                    v-model="chart.extra.dataLabel"
                  >
                    数据标签
                  </el-checkbox>
                  <div class="content-item" v-else>
                    <el-checkbox
                      v-model="chart.extra.dataLabel"
                      @input="setAttr($event, 'labelPosition')"
                    >
                      数据标签
                    </el-checkbox>
                    <div class="detail" v-if="chart.extra.dataLabel">
                      <el-radio-group v-model="chart.extra.labelPosition" size="medium">
                        <el-radio-button label="inside">中</el-radio-button>
                        <el-radio-button label="right">右</el-radio-button>
                      </el-radio-group>
                    </div>
                  </div>
                  <div class="content-item">
                    <el-checkbox
                      v-model="chart.extra.showLegend"
                      @input="setAttr($event, 'legend')"
                    >
                      显示图例
                    </el-checkbox>
                    <div class="detail" v-if="chart.extra.showLegend">
                      <el-radio-group v-model="chart.extra.legend" size="medium">
                        <el-radio-button label="top">上</el-radio-button>
                        <el-radio-button label="bottom">下</el-radio-button>
                        <el-radio-button label="left">左</el-radio-button>
                        <el-radio-button label="right">右</el-radio-button>
                      </el-radio-group>
                    </div>
                  </div>
                  <div class="content-item">
                    <el-checkbox
                      :value="!!chart.extra.filterNumber"
                      @input="setAttr($event, 'filterNumber')"
                    >
                      数据过滤
                    </el-checkbox>
                    <div class="detail" v-if="!!chart.extra.filterNumber">
                      <span>显示前</span>
                      <el-input-number
                        v-model="chart.extra.filterNumber"
                        :controls="false"
                        :min="0"
                        size="small"
                        class="value"
                      ></el-input-number>
                      <span>项</span>
                    </div>
                  </div>
                  <el-checkbox
                    v-if="['bar', 'stacked-bar'].includes(chart.type)"
                    class="content-item"
                    v-model="chart.extra.showSort"
                  >
                    显示排序
                  </el-checkbox>
                </div>
              </div>
              <div class="item">
                <div class="title">坐标轴</div>
                <div class="content">
                  <el-checkbox class="content-item" v-model="chart.extra.incline">
                    智能倾斜维度值
                  </el-checkbox>
                  <el-checkbox class="content-item" v-model="chart.extra.abbreviated">
                    智能显示缩略轴
                  </el-checkbox>
                  <div class="content-item" v-if="!['bar', 'stacked-bar'].includes(chart.type)">
                    <el-checkbox v-model="chart.extra.doubleY" @input="clearYAxisSetting">
                      显示双Y轴
                    </el-checkbox>
                    <div class="axis-detail" v-if="chart.extra.doubleY">
                      <div class="info">
                        <span class="label">左Y轴</span>
                        <normal-select
                          :select-list="getOptions('right')"
                          :selected-item.sync="chart.extra.left"
                          filterable
                          multiple
                        ></normal-select>
                      </div>
                      <div class="info">
                        <span class="label">右Y轴</span>
                        <normal-select
                          :select-list="getOptions('left')"
                          :selected-item.sync="chart.extra.right"
                          filterable
                          multiple
                        ></normal-select>
                      </div>
                    </div>
                  </div>
                  <div class="content-item">
                    <el-checkbox
                      :value="chart.extra.xAxisTitle !== null"
                      @input="setAttr($event, 'xAxisTitle')"
                    >
                      显示x轴标题
                    </el-checkbox>
                    <div class="detail" v-if="chart.extra.xAxisTitle !== null">
                      <el-input v-model="chart.extra.xAxisTitle"></el-input>
                    </div>
                  </div>
                  <div class="content-item">
                    <el-checkbox v-model="chart.extra.showYAxisTitle" @input="clearYAxisTitle">
                      显示y轴标题
                    </el-checkbox>
                    <div class="axis-detail" v-if="chart.extra.showYAxisTitle">
                      <template
                        v-if="!chart.extra.doubleY || ['bar', 'stacked-bar'].includes(chart.type)"
                      >
                        <el-input v-model="chart.extra.yAxisTitle"></el-input>
                      </template>
                      <template v-else>
                        <div class="info">
                          <span class="label">左Y轴</span>
                          <el-input v-model="chart.extra.yAxisTitle"></el-input>
                        </div>
                        <div class="info">
                          <span class="label">右Y轴</span>
                          <el-input v-model="chart.extra.rightYAxisTitle"></el-input>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item list">
                <div class="title">
                  辅助线
                  <el-button type="text" @click="addLine">+添加</el-button>
                </div>
                <div class="content" v-ps>
                  <div v-for="line in chart.extra.lines" :key="line.id" class="list-item">
                    <span v-tip>{{ line.name }}</span>
                    <i
                      class="el-icon-edit-outline list-operation"
                      style="font-size: 15px"
                      @click="editLine(line)"
                    ></i>
                    <i
                      class="el-icon-delete list-operation"
                      style="font-size: 15px"
                      @click="delLine(line.id)"
                    ></i>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="['ring-diagram', 'pie'].includes(chart.type)">
              <div class="item">
                <div class="title">图表样式</div>
                <div class="content">
                  <div class="content-item">
                    <el-checkbox
                      :value="!_.isEmpty(chart.extra.label)"
                      @input="setAttr($event, 'label')"
                    >
                      数据标签
                    </el-checkbox>
                    <div class="detail" v-if="!_.isEmpty(chart.extra.label)">
                      <el-checkbox-group v-model="chart.extra.label" size="medium">
                        <el-checkbox label="tag">标签</el-checkbox>
                        <el-checkbox label="number">数字</el-checkbox>
                        <el-checkbox label="percent">占比</el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <div class="content-item">
                    <el-checkbox
                      v-model="chart.extra.showLegend"
                      @input="setAttr($event, 'legend')"
                    >
                      显示图例
                    </el-checkbox>
                    <div class="detail" v-if="chart.extra.showLegend">
                      <el-radio-group v-model="chart.extra.legend" size="medium">
                        <el-radio-button label="top">上</el-radio-button>
                        <el-radio-button label="bottom">下</el-radio-button>
                        <el-radio-button label="left">左</el-radio-button>
                        <el-radio-button label="right">右</el-radio-button>
                      </el-radio-group>
                    </div>
                  </div>
                  <div class="content-item">
                    <el-checkbox
                      :value="!!chart.extra.filterNumber"
                      @input="setAttr($event, 'filterNumber')"
                    >
                      数据过滤
                    </el-checkbox>
                    <div class="detail" v-if="!!chart.extra.filterNumber">
                      <span>显示前</span>
                      <el-input-number
                        v-model="chart.extra.filterNumber"
                        :controls="false"
                        :min="0"
                        size="small"
                        class="value"
                      ></el-input-number>
                      <span>项</span>
                    </div>
                  </div>
                  <el-checkbox class="content-item" v-model="chart.extra.showTotal">
                    显示总计
                  </el-checkbox>
                </div>
              </div>
            </template>
            <template v-else-if="['funnel'].includes(chart.type)">
              <div class="item">
                <div class="title">图表样式</div>
                <div class="content">
                  <div class="content-item">
                    <el-checkbox
                      :value="!_.isEmpty(chart.extra.label)"
                      @input="setAttr($event, 'label')"
                    >
                      数据标签
                    </el-checkbox>
                    <div class="detail" v-if="!_.isEmpty(chart.extra.label)">
                      <el-checkbox-group v-model="chart.extra.label" size="medium">
                        <el-checkbox label="tag">标签</el-checkbox>
                        <el-checkbox label="quota">指标值</el-checkbox>
                        <div class="percent">
                          <el-checkbox label="percent">
                            转化率：
                          </el-checkbox>
                          <el-select v-model="chart.extra.percentType">
                            <el-option label="占上一层的百分比" value="last"></el-option>
                            <el-option label="占第一层的百分比" value="first"></el-option>
                          </el-select>
                        </div>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <div class="content-item">
                    <el-checkbox
                      v-model="chart.extra.showLegend"
                      @input="setAttr($event, 'legend')"
                    >
                      显示图例
                    </el-checkbox>
                    <div class="detail" v-if="chart.extra.showLegend">
                      <el-radio-group v-model="chart.extra.legend" size="medium">
                        <el-radio-button label="top">上</el-radio-button>
                        <el-radio-button label="bottom">下</el-radio-button>
                        <el-radio-button label="left">左</el-radio-button>
                        <el-radio-button label="right">右</el-radio-button>
                      </el-radio-group>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="['map'].includes(chart.type)">
              <div class="item">
                <div class="title">图表样式</div>
                <div class="content">
                  <div class="content-item">
                    <el-checkbox
                      :value="!_.isEmpty(chart.extra.label)"
                      @input="setAttr($event, 'label')"
                    >
                      数据标签
                    </el-checkbox>
                    <div class="detail" v-if="!_.isEmpty(chart.extra.label)">
                      <el-checkbox-group v-model="chart.extra.label" size="medium">
                        <el-checkbox label="dimension">维度</el-checkbox>
                        <el-checkbox label="quota">指标</el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <div class="content-item">
                    <el-checkbox :value="!!chart.extra.legend" @input="setAttr($event, 'legend')">
                      显示图例
                    </el-checkbox>
                    <div class="detail" v-if="!!chart.extra.legend">
                      <el-radio-group v-model="chart.extra.legend" size="medium">
                        <el-radio-button label="top">上</el-radio-button>
                        <el-radio-button label="bottom">下</el-radio-button>
                        <el-radio-button label="left">左</el-radio-button>
                        <el-radio-button label="right">右</el-radio-button>
                      </el-radio-group>
                    </div>
                  </div>
                  <el-checkbox class="content-item" v-model="chart.extra.showTotal">
                    显示总计
                  </el-checkbox>
                </div>
              </div>
            </template>
            <template v-else-if="chart.type === 'indicator'">
              <div class="item">
                <span class="title">图表样式</span>
                <el-form class="indicator-form">
                  <el-form-item label="名称" v-model="chart.extra">
                    <el-color-picker
                      size="small"
                      style="position:relative;top:10px"
                      v-model="chart.extra.indicatorStyle.titleColor"
                    ></el-color-picker>
                    <el-input
                      style="width: 165px;margin-left: 5px"
                      v-model="chart.extra.indicatorStyle.titleFontsize"
                    >
                      <i
                        slot="suffix"
                        style="margin-top: 4px;margin-right: 3px;display: inline-block"
                      >
                        px
                      </i>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="数值">
                    <el-color-picker
                      size="small"
                      style="position:relative;top:10px"
                      v-model="chart.extra.indicatorStyle.numColor"
                    ></el-color-picker>
                    <el-input
                      style="width: 165px;margin-left: 5px"
                      v-model="chart.extra.indicatorStyle.numFontsize"
                    >
                      <i
                        slot="suffix"
                        style="margin-top: 4px;margin-right: 3px;display: inline-block"
                      >
                        px
                      </i>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="前缀">
                    <el-input v-model="chart.extra.indicatorStyle.before"></el-input>
                  </el-form-item>
                  <el-form-item label="后缀">
                    <el-input v-model="chart.extra.indicatorStyle.after" :width="186"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="item">
                <div class="title">跳转</div>
                <div class="content">
                  <el-checkbox class="content-item" v-model="chart.needIds">
                    跳转原数据
                  </el-checkbox>
                </div>
              </div>
            </template>
            <template v-else-if="chart.type === 'cross-table'">
              <div class="item">
                <div class="title">默认排序</div>
                <div class="content">
                  <template v-if="quotaList && quotaList.length">
                    <div class="content-item sort-item">
                      <div class="label">指标</div>
                      <normal-select
                        :select-list="quotaList"
                        :selected-item.sync="chart.extra.sortQuota"
                        filterable
                      ></normal-select>
                    </div>
                    <div class="content-item sort-item">
                      <div class="label">排序</div>
                      <normal-select
                        :select-list="sortMethods"
                        :selected-item.sync="chart.extra.sortMethod"
                        filterable
                      ></normal-select>
                    </div>
                    <div class="content-item sort-item">
                      <div class="label">维度</div>
                      <normal-select
                        :select-list="xAxisList"
                        :selected-item.sync="chart.extra.sortGroup"
                        filterable
                      ></normal-select>
                    </div>
                  </template>
                  <div class="content-item">
                    <el-checkbox v-model="chart.extra.showNumber">
                      显示序号
                    </el-checkbox>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="title">总计配置</div>
                <div class="content">
                  <div class="content-item">
                    <div>行总计</div>
                    <total
                      :chart="chart"
                      title="整体汇总"
                      can-set-property="rowTotal"
                      list-property="rowTotalList"
                      position-property="rowTotalPosition"
                    ></total>
                  </div>
                  <div class="content-item">
                    <div>列总计</div>
                    <total
                      :chart="chart"
                      title="整体汇总"
                      can-set-property="columnTotal"
                      list-property="columnTotalList"
                      position-property="columnTotalPosition"
                    ></total>
                    <total
                      :chart="chart"
                      title="分类汇总"
                      can-set-property="kindColumnTotal"
                      list-property="kindColumnTotalList"
                    ></total>
                  </div>
                </div>
              </div>
              <div class="item list">
                <div class="title">
                  条件格式
                  <el-button type="text" @click="addRule">+添加规则</el-button>
                </div>
                <div class="content" v-ps>
                  <div v-for="rule in chart.extra.rules" :key="rule.id" class="list-item">
                    <span v-tip>
                      {{ quotaMap[rule.quota] ? quotaMap[rule.quota].name : "指标不存在" }}
                    </span>
                    <i
                      class="el-icon-edit-outline list-operation"
                      style="font-size: 15px"
                      @click="editRule(rule)"
                    ></i>
                    <i
                      class="el-icon-delete list-operation"
                      style="font-size: 15px"
                      @click="delRule(rule.id)"
                    ></i>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="title">跳转</div>
                <div class="content">
                  <el-checkbox class="content-item" v-model="chart.needIds">
                    跳转原数据
                  </el-checkbox>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
    <line-dialog
      ref="line"
      :operation="operation"
      :line="line"
      @submit="setLine"
      :quotas="chart.yAxisList"
    ></line-dialog>
    <rule-dialog
      ref="rule"
      :operation="operation"
      :rule="rule"
      :extra-rules="chart.extra.rules"
      @submit="setRule"
      :quotas="chart.yAxisList"
    ></rule-dialog>
  </div>
</template>

<script>
import { chartMenus, sortMethods } from "@/views/Backend/Admin/Statistics/chartEdit/static"
import BoardMenu from "@/views/Backend/Admin/Statistics/sideNav/BoardMenu"
import LineDialog from "@/views/Backend/Admin/Statistics/chartEdit/LineDialog"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import { randomString } from "@/utils/common"
import Total from "@/views/Backend/Admin/Statistics/chartEdit/Total"
import RuleDialog from "@/views/Backend/Admin/Statistics/chartEdit/RuleDialog"

export default {
  name: "side-menu",
  components: { RuleDialog, Total, NormalSelect, LineDialog, BoardMenu },
  props: {
    chart: Object,
    quotas: Array
  },
  data() {
    return {
      chartMenus,
      sortMethods,
      curTab: "样式配置",
      crossExtra: {
        rowTotal: false,
        rowTotalPosition: "right",
        rowTotalList: [],
        columnTotal: false,
        columnTotalPosition: "bottom",
        columnTotalList: [],
        kindColumnTotal: false,
        kindColumnTotalPosition: "bottom",
        kindColumnTotalList: [],
        rules: [],
        sortQuota: null,
        sortMethod: null,
        sortGroup: null,
        showNumber: false
      },
      pieExtra: {
        label: [],
        legend: "top",
        showLegend: true,
        filterNumber: null,
        showTotal: false,
        percentType: "last"
      },
      extra: {
        dataLabel: true,
        labelPosition: "inside",
        showLegend: true,
        legend: "top",
        filterNumber: null,
        showSort: false,
        showTotal: false,
        incline: false,
        abbreviated: false,
        doubleY: false,
        left: [],
        right: [],
        xAxisTitle: null,
        showYAxisTitle: false,
        yAxisTitle: null,
        rightYAxisTitle: null,
        lines: [],
        indicatorStyle: {
          titleColor: "#555555",
          titleFontsize: "14",
          numColor: "#555555",
          numFontsize: "48",
          before: "",
          after: ""
        }
      },
      operation: "addLine",
      line: {
        name: "",
        kind: "fixed",
        number: "",
        cid: "",
        calc: "",
        color: ""
      },
      rule: {
        quota: "",
        type: "区间色",
        conditions: [
          {
            startValue: null,
            startMethod: "<=",
            endValue: null,
            endMethod: "<",
            background: "#fff",
            color: "#303133"
          }
        ],
        colorScheme: "sky",
        positive: "rgb(255, 208, 129)",
        negative: "rgb(181, 158, 251)"
      }
    }
  },
  created() {
    this.setChartExtra()
  },
  computed: {
    quotaMap() {
      return this._.keyBy(this.chart.yAxisList, "id")
    },
    quotaList() {
      let yXAxis = this.chart.xAxisList?.filter(xAxis => xAxis.type === "COLUMN")
      return yXAxis?.length
        ? []
        : this.chart.yAxisList
            ?.filter(yAxis => !yAxis.hidden)
            .map(yAxis => ({ label: yAxis.name, value: yAxis.id }))
    },
    xAxisList() {
      let list =
        this.chart.xAxisList
          ?.filter(xAxis => !xAxis.hidden && xAxis.type !== "COLUMN")
          .map(xAxis => ({ label: xAxis.name, value: xAxis.id })) || []
      return list.length > 0 ? list.slice(0, list.length - 1) : list
    }
  },
  methods: {
    setChartExtra() {
      let extra = {}
      switch (this.chart.type) {
        case "ring-diagram":
        case "pie":
        case "map":
        case "funnel":
          extra = this.pieExtra
          break
        case "cross-table":
          extra = this.crossExtra
          break
        default:
          extra = this.extra
          break
      }
      this._.keys(this.chart).includes("extra")
        ? this.$set(this.chart, "extra", Object.assign({}, extra, this.chart.extra))
        : this.$set(this.chart, "extra", extra)
    },
    selectMenu(menu) {
      this.curTab = menu.name
      this.$emit("change", this.curTab)
    },
    changeDataPermission(val) {
      if (val) {
        this.chart.canSeeAll = null
      } else {
        this.chart.canSeeAll = true
        this.chart.canExportImage = true
        this.chart.canExportExcel = true
      }
    },
    setAttr(val, attr) {
      let result = null
      switch (attr) {
        case "legend":
          result = val ? "top" : null
          break
        case "labelPosition":
          result = val ? "inside" : null
          break
        case "filterNumber":
          result = val ? 10 : null
          break
        case "xAxisTitle":
        case "yAxisTitle":
          result = val ? "" : null
          break
        case "label":
          if (["pie", "ring-diagram"].includes(this.chart.type)) result = val ? ["tag"] : []
          else if (this.chart.type === "funnel") result = val ? ["quota"] : []
          else if (this.chart.type === "map") result = val ? ["dimension"] : []
      }
      this.chart.extra[attr] = result
    },
    addLine() {
      this.operation = "addLine"
      this.line = this.$options.data().line
      this.line.id = randomString(10)
      this.$nextTick(() => {
        this.$refs.line?.open()
      })
    },
    addRule() {
      this.operation = "addRule"
      this.rule = this.$options.data().rule
      this.rule.id = randomString(10)
      this.$nextTick(() => {
        this.$refs.rule?.open()
      })
    },
    editLine(item) {
      this.operation = "editLine"
      this.line = item
      this.$nextTick(() => {
        this.$refs.line?.open()
      })
    },
    editRule(item) {
      this.operation = "editRule"
      this.rule = item
      this.$nextTick(() => {
        this.$refs.rule?.open()
      })
    },
    delLine(id) {
      this.chart.extra.lines.splice(
        this.chart.extra.lines.findIndex(line => line.id === id),
        1
      )
    },
    delRule(id) {
      this.chart.extra.rules.splice(
        this.chart.extra.rules.findIndex(rule => rule.id === id),
        1
      )
    },
    setLine(line) {
      switch (this.operation) {
        case "addLine":
          this.chart.extra.lines.push(line)
          break
        case "editLine":
          this.chart.extra.lines.splice(
            this.chart.extra.lines.findIndex(l => l.id === line.id),
            1,
            line
          )
          break
      }
    },
    setRule(rule) {
      switch (this.operation) {
        case "addRule":
          this.chart.extra.rules.push(rule)
          break
        case "editRule":
          this.chart.extra.rules.splice(
            this.chart.extra.rules.findIndex(r => r.id === rule.id),
            1,
            rule
          )
          break
      }
    },
    getOptions(filterField) {
      let selectedIds = this.chart.extra[filterField]
      return this.chart.yAxisList
        ?.filter(yAxis => !yAxis.hidden && !selectedIds.includes(yAxis.id))
        .map(yAxis => ({ label: yAxis.name, value: yAxis.id }))
    },
    clearYAxisSetting(val) {
      this.chart.extra.left = []
      this.chart.extra.right = []
      this.chart.extra.showYAxisTitle = false
      this.clearYAxisTitle()
    },
    clearYAxisTitle() {
      this.chart.extra.yAxisTitle = null
      this.chart.extra.rightYAxisTitle = null
    }
  }
}
</script>

<style lang="scss" scoped>
.side-menu {
  height: 100%;
  border-left: 2px solid #e4e7ed;
  .show-name {
    margin-top: 10px;
  }
  .menu-wrapper {
    height: 100%;
    display: flex;
    flex-flow: column;
    .basic-info {
      margin: 0 15px;
      font-size: 14px;
      .item {
        .title {
          font-weight: 500;
        }
        .content {
          .content-item {
            display: flex;
            margin: 15px 0;
            .label {
              margin-right: 10px;
              width: 80px;
              text-align: right;
            }
            .value {
              flex: 1;
            }
          }
        }
        ::v-deep {
          .el-textarea__inner {
            resize: none;
          }
        }
      }
    }
    .style-setting {
      margin: 0 15px;
      font-size: 14px;
      display: flex;
      flex-flow: column;
      height: calc(100% - 96px);
      .indicator-form {
        margin-top: 10px;
        .el-form-item {
          display: flex;
          align-items: center;
          .el-form-item__content {
            display: flex;
            align-items: center;
          }
        }
      }
      .item {
        .title {
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          .el-button {
            padding: 0;
            font-size: 13px;
          }
        }
        .content {
          margin: 15px 0;
          .sort-item {
            display: flex;
            align-items: center;
            .label {
              width: 48px;
            }
          }
          .content-item {
            margin-bottom: 15px;
            .detail {
              margin-top: 15px;
              margin-left: 24px;
              display: flex;
              align-items: center;
              .value {
                flex: 1;
                margin: 0 4px;
              }
            }
            .axis-detail {
              margin-top: 15px;
              margin-left: 24px;
              .info {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                .label {
                  width: 60px;
                }
              }
            }
            .percent {
              display: flex;
              align-items: center;
              .el-select {
                width: 160px;
              }
              ::v-deep {
                .el-input__inner {
                  border: none;
                  padding: 0;
                  color: #409eff;
                }
                .el-input__suffix {
                  right: 24px;
                }
              }
            }
          }
        }
      }
      .list {
        flex: 1;
        .list-item {
          line-height: 40px;
          height: 40px;
          font-size: 13px;
          align-items: center;
          display: flex;
          background-color: #ecf5ff;
          border-radius: 4px;
          padding: 0 10px;
          margin-bottom: 4px;
          .list-operation {
            visibility: hidden;
            color: #909399;
            margin-right: 5px;
          }
          &:hover {
            .list-operation {
              visibility: visible;
            }
          }
        }
      }
    }
  }
  ::v-deep {
    .el-input-number .el-input__inner {
      text-align: left;
    }
  }
}
</style>
